import { Horizontal, Vertical } from "gls";
import React, { ReactNode } from "react";
import { StyledSlidingPane } from "./styles";

type FlyoutProps = {
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
  headerIcon?: ReactNode;
  headerTitle: string | ReactNode;
  footer?: ReactNode
  id?: string
};

export const Flyout = (props: FlyoutProps) => {
  const {
    headerTitle,
    onClose,
    footer,
    id = 'flyout'
  } = props;

  return (
    <StyledSlidingPane
      isOpen={props.isOpen}
      onRequestClose={onClose}
      title={headerTitle}
    >
      <Vertical spacing={0} sizing="stretch" className="content" id={`${id}-content`}>
        {props.children}
      </Vertical>
      {footer && (
        <Horizontal horizontalAlign="right" className="footer" spacing={5} id={`${id}-footer`}>
          {footer}
        </Horizontal>
      )}
    </StyledSlidingPane>
  );
};

